import { withCurrentParams } from 'actions/utils';
import { BROADCAST_SAVE_TEMPLATE } from 'actions/Types';
import addTemplateToOverlays from './addTemplateToOverlays';
import addTemplateToBackground from './addTemplateToBackground';
import addTemplateToMedia from './addTemplateToMedia';
import { updateSource } from 'actions/Broadcast';
import { getFileSourceType } from '@shoflo/polymer';

const OVERLAYS = 'overlays';
const BACKGROUNDS = 'backgrounds';
const MEDIA = 'media';

export default template => {
  return withCurrentParams((dispatch, { teamId, eventId, broadcastId }) => {
    const action = {
      type: BROADCAST_SAVE_TEMPLATE,
      request: async apiClient => {
        const payload = {
          type: template.type,
          templateS3Key: template.title
        };
        let eventDoc;
        if (template.isEventTemplate) {
          eventDoc = {
            _id: template._id ? template._id : template.value?.eventDocId
          };
        } else {
          eventDoc = await apiClient.broadcast.copyTemplate(
            teamId,
            eventId,
            broadcastId,
            payload
          );
        }

        if (template.type === BACKGROUNDS) {
          dispatch(addTemplateToBackground(eventDoc, template));
        }
        if (template.type === OVERLAYS) {
          dispatch(addTemplateToOverlays(eventDoc, template));
        }
        if (template.type === MEDIA) {
          if (template.sourceId) {
            //When media is assigned to content placeHolder, we need to update the source
            dispatch(
              updateSource(template.sourceId, {
                type: getFileSourceType(template.title),
                title: template.title,
                value: { ...template.value, eventDocId: eventDoc._id }
              })
            );
          } else {
            dispatch(addTemplateToMedia(eventDoc, template));
          }
        }
        return eventDoc;
      }
    };
    dispatch(action);
  });
};
